import * as React from 'react';
import {
	AutocompleteInput,
	Edit,
	EditProps,
	NumberInput, ReferenceArrayInput,
	ReferenceInput, SelectArrayInput,
	SelectInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { UploadImage } from '../components/UploadImage';
import { ELanguage } from '../enums';

export const TrainingEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<UploadImage step={1} source="featuredImageUrl" label="FEATURED_IMAGE"/>
				<TextInput step={1} source="name" label="NAME"/>
				<TextInput multiline step={1} source="description" label="DESCRIPTION"/>
				<ReferenceInput
					step={1}
					label="CATEGORY"
					source="categoryId" reference="training-categories"
					alwaysOn
				>
					<AutocompleteInput optionText="name"/>
				</ReferenceInput>
				<ReferenceArrayInput
					step={1}
					label="TAGS"
					source="tagsIds" // this should match the field name in your API
					reference="tags" // this should match the endpoint for tags in your API
				>
					<SelectArrayInput optionText="title" />
				</ReferenceArrayInput>
				<TextInput type="url" step={1} source="videoUrl" label="YOUTUBE_LINK"/>
				<TextInput type="url" step={1} source="externalUrl" label="EXTERNAL_LINK"/>
				<TextInput type="url" step={1} source="iframeUrl" label="IFRAME_URL"/>
				<NumberInput type="number" step={1} source="order" label="ORDER"/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Edit>
	);
};
